<template>
  <div :class="ismobile">
    <div class="banner">
      <el-carousel :height="ismobile == 'qiuz' ? '320px' : '160px'">
        <el-carousel-item v-for="item in swiper" :key="item.id">
          <img
            class="banners"
            :src="'https://hcrl.huicairen.net' + item.img"
            alt=""
          />
        </el-carousel-item>
      </el-carousel>
      <!-- <div>
        <img class="banners" src="../static/home_banner_bg.png" alt="" />
      </div> -->
    </div>
    <div class="address">
      <img class="icons" src="../static/address_icon.png" alt="" />
      您所在的位置：求职登记
    </div>
    <!-- <div> -->
    <div class="mainform">
      <div class="title">求职登记</div>
      <!-- <div>{{ ismobile }}</div> -->
      <div class="form">
        <ul class="uls">
          <li v-for="item in forms" style="width: 100%" :key="item.name">
            <div v-if="!item.iscode" class="form_item">
              <img class="form_icon" :src="item.src" alt="" />
              <span v-if="item.isrequ" class="required">*</span>
              <input
                class="forminp"
                type="text"
                :placeholder="item.name"
                v-model="item.inp"
                name=""
                id=""
              />
            </div>
            <div class="codeitem" v-if="item.iscode">
              <div class="form_item1">
                <img class="form_icon" :src="item.src" alt="" />
                <span v-if="item.isrequ" class="required">*</span>
                <input
                  class="forminp"
                  type="text"
                  :placeholder="item.name"
                  v-model="item.inp"
                  name=""
                  id=""
                />
              </div>
              <div @click="getcode" class="fasong">{{ codes }}</div>
            </div>
          </li>
        </ul>
        <div class="submits" @click="submits">提交</div>
      </div>
    </div>
    <!-- </div> -->
    <el-dialog
      title="申请免费入职"
      :visible.sync="centerDialogVisible"
      :width="ismobile == 'qiuz' ? '360px' : '180px'"
      center
    >
      <div style="texts">
        您的报名信息已提交，我们的招聘顾问会尽快与您 取得联系！
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button
          style="background-color: #da251c; color: #fff"
          @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import md5 from "js-md5";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      // form: {
      //   name: "",
      //   tel: "",
      //   code: "",
      //   job: "",
      //   address: "",
      //   wages: "",
      // },
      swiper: [],
      centerDialogVisible: false,
      codes: "发送验证码",
      forms: [
        {
          name: "姓名",
          inp: "",
          src: require("../static/icon_register_name_ico.png"),
          isrequ: true,
        },
        {
          name: "手机号码",
          inp: "",
          src: require("../static/icon_register_shou_ico.png"),
          isrequ: true,
        },
        {
          name: "验证码",
          inp: "",
          src: require("../static/icon_register_yanz_ico.png"),
          isrequ: false,
          iscode: true,
        },
        {
          name: "意向工作",
          inp: "",
          src: require("../static/icon_register_work_ico.png"),
          isrequ: false,
        },
        {
          name: "期望地点",
          inp: "",
          src: require("../static/icon_register_didian_ico.png"),
          isrequ: false,
        },
        {
          name: "期待薪资",
          inp: "",
          src: require("../static/icon_register_qiw_ico.png"),
          isrequ: false,
        },
      ],
      windowWidth: document.documentElement.clientWidth,
    };
  },
  computed: {
    ismobile() {
      console.log(this.windowWidth);
      if (this.windowWidth > 500) {
        return "qiuz";
      } else {
        return "mobiles";
      }
    },
  },
  watch: {},
  methods: {
    submits() {
      // this.centerDialogVisible = true;
      if (!this.forms[0].inp || !this.forms[1].inp || !this.forms[2].inp) {
        this.$message.error("请输入完整的信息");
        return;
      }
      this.$api
        .position({
          name: this.forms[0].inp,
          tel: this.forms[1].inp,
          code: this.forms[2].inp,
          job: this.forms[3].inp,
          address: this.forms[4].inp,
          wages: this.forms[5].inp,
          flag: 2,
          pwd: md5(md5(this.forms[1].inp) + "FHD^*3la2" + this.forms[2].inp),
        })
        .then((data) => {
          console.log(data);
          if (data.data.code == 0) {
            this.centerDialogVisible = true;
            this.forms.forEach((item) => {
              item.inp = "";
            });
          } else {
            this.$message.error(data.data.msg);
          }
        });
    },
    getbanner() {
      this.$api.banner().then((data) => {
        console.log(data, "轮播图");
        if (data.data.code == 0) {
          this.swiper = data.data.data;
        } else {
          this.$message.error(data.data.msg);
        }
      });
    },
    getcode() {
      if (this.forms[1].inp) {
        if (this.codes == "发送验证码" || this.codes == "重新发送") {
          this.$api
            .sms({
              tel: this.forms[1].inp,
              code: md5(md5(this.forms[1].inp) + "FHD^*3la2"),
            })
            .then((data) => {
              if (data.data.code == 0) {
                this.$message({
                  message: data.data.msg,
                  type: "success",
                });
                let num = 60;
                let time = setInterval(() => {
                  num--;
                  this.codes = `${num}S后重发`;
                  if (num == 0) {
                    clearInterval(time);
                    this.codes = "重新发送";
                  }
                }, 1000);
              } else {
                this.$message.error(data.data.msg);
                return;
              }
            });
        } else {
          this.$message.error("发送间隔过短");
          return;
        }
      } else {
        this.$message.error("请输入手机号");
        return;
      }
    },
  },
  created() {
    this.getbanner();
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.texts {
  text-align: center;
}
// 手机端
.mobiles {
  width: 100%;
  .banner {
    width: 100%;
    height: 160px;
    //   font-size: 0px;
    //   margin-bottom: 40px;
    .banners {
      width: 100%;
      height: 160px;
      // font-size: 0px;
    }
  }
  .address {
    width: 100%;
    height: 40px;
    background: #ffffff;
    padding-left: 30px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
    box-sizing: border-box;
    .icons {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  .mainform {
    width: 100%;
    //   height: 649px;
    background: #ffffff;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 30px;
    .title {
      font-size: 30px;
      color: #da251c;
      font-weight: bold;
      height: 60px;
      line-height: 60px;
    }
    .form {
      background-image: url("../static/register_chahua_bg.png");
      background-size: 100%;
      background-repeat: no-repeat;
      width: 100%;
      height: 530px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .uls {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .form_item {
        width: 80%;
        height: 50px;
        background: #f0f0f0;
        display: flex;
        align-items: center;
        padding-left: 10px;
        margin: 0 auto;
        box-sizing: border-box;
        margin-bottom: 10px;
      }
      .codeitem {
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 80%;
        margin-bottom: 10px;
      }
      .fasong {
        width: 40%;
        height: 50px;
        background: linear-gradient(-33deg, #d7d7d7, #ffffff);
        border: 1px solid #e5e5e5;
        font-size: 14px;
        color: #333;
        text-align: center;
        line-height: 50px;
        box-sizing: border-box;
        cursor: pointer;
      }
      .form_item1 {
        width: 58%;
        height: 50px;
        background: #f0f0f0;
        display: flex;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;
        //   margin-bottom: 10px;
      }
      .required {
        font-size: 14px;
        color: #da251c;
      }
      .forminp {
        border: none;
        background-color: transparent;
        outline: none;
      }
      .form_icon {
        width: 16px;
        height: 18px;
        margin-right: 10px;
      }
      .submits {
        width: 150px;
        height: 50px;
        background: #da251c;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        line-height: 50px;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
}
// pc
.qiuz {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .banner {
    width: 100%;
    height: 320px;
    //   font-size: 0px;
    //   margin-bottom: 40px;
    .banners {
      width: 100%;
      height: 320px;
      // font-size: 0px;
    }
  }
  .address {
    width: 100%;
    height: 40px;
    background: #ffffff;
    padding-left: 158px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
    box-sizing: border-box;
    .icons {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  .mainform {
    width: 80%;
    //   height: 649px;
    background: #ffffff;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 40px;
    margin-bottom: 60px;
    .title {
      font-size: 30px;
      color: #da251c;
      font-weight: bold;
      height: 120px;
      line-height: 120px;
    }
    .form {
      background-image: url("../static/register_chahua_bg.png");
      background-size: 100% 100%;
      width: 100%;
      height: 530px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .form_item {
        width: 400px;
        height: 50px;
        background: #f0f0f0;
        display: flex;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;
        margin-bottom: 10px;
      }
      .codeitem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 400px;
        margin-bottom: 10px;
      }
      .fasong {
        width: 141px;
        height: 50px;
        background: linear-gradient(-33deg, #d7d7d7, #ffffff);
        border: 1px solid #e5e5e5;
        font-size: 14px;
        color: #333;
        text-align: center;
        line-height: 50px;
        box-sizing: border-box;
        cursor: pointer;
      }
      .form_item1 {
        width: 250px;
        height: 50px;
        background: #f0f0f0;
        display: flex;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;
        //   margin-bottom: 10px;
      }
      .required {
        font-size: 14px;
        color: #da251c;
      }
      .forminp {
        border: none;
        background-color: transparent;
        outline: none;
      }
      .form_icon {
        width: 16px;
        height: 18px;
        margin-right: 10px;
      }
      .submits {
        width: 150px;
        height: 50px;
        background: #da251c;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        line-height: 50px;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
